const DOMAIN = 'cobranded.services.userSettings.privateArea.downloadapp.modal';

export const MODAL_PRIMARY_BUTTON = `${DOMAIN}.primaryButton`;